import { render } from "./VgtTableHeader.vue?vue&type=template&id=5cef0e30"
import script from "./VgtTableHeader.vue?vue&type=script&lang=js"
export * from "./VgtTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__